import { MCApprovalTypeId } from "@maslul/common-services";

export abstract class ApprovalTypeData {

    public static approvalTypeToExcludeCountriesGroup: any[] = [
        MCApprovalTypeId.TRANSPORT_COMMERCIAL_USED,
        MCApprovalTypeId.TRANSPORT_PRODUCTS_COMMERCIAL,
        MCApprovalTypeId.TRANSPORT_IMPORT_TO_EXPORT,
        MCApprovalTypeId.QUOTA_LICENSE_3,
        MCApprovalTypeId.QUOTA_LICENSE_4,
        MCApprovalTypeId.QUOTA_LICENSE_5,
        MCApprovalTypeId.QUOTA_LICENSE_6,
        MCApprovalTypeId.TRAINS23,
        MCApprovalTypeId.TRAINS0211,
        MCApprovalTypeId.TRANSPORT_VESSEL,
        MCApprovalTypeId.TRANSPORT_COMMERCIAL_USED,
        MCApprovalTypeId.FOOD_REQUEST
    ];
    public static communicationApprovals = [
        MCApprovalTypeId.COMMUNICATION_TYPE_DISPOSABLE,
        MCApprovalTypeId.COMMUNICATION_TYPE_PERIODIC,
        MCApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_COMMERCIAL,
        MCApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_PRIVATE,
        MCApprovalTypeId.COMMUNICATION_ADJUSTMENT_PERIODIC,
        //MCApprovalTypeId.COMMUNICATION_ADJUSTMENT_PERIODIC_DECLARATION
    ];


    public static approvalOfManufacturerNameList = [
        ApprovalTypeData.communicationApprovals,
    ];

    public static isPackageYoursFieldDisplay = [
        MCApprovalTypeId.PersonalImport
    ];
}